// @flow
type TExercise = {
    currentStageId?: string,
    data?: Object,
};

type TExerciseState = {
    data: TExercise,
};
const initialState: TExerciseState = {
    data: {},
};

type TSetExercise = {payload: TExercise, type: 'SET_EXERCISE'};

type TExerciseActionList = TSetExercise;

function exerciseReducer(state: TExerciseState = initialState, {type, payload}: TExerciseActionList) {
    switch (type) {
        case 'SET_EXERCISE': {
            const newData = {...state.data};
            Object.keys(payload).forEach((blockKey) => {
                newData[blockKey] = {
                    ...newData[blockKey],
                    ...payload[blockKey],
                };
            });
            return {
                ...state,
                data: newData,
            };
        }
        case 'SET_EXERCISE_RESULT_DATA':
            return {
                ...state,
                result: payload,
            };
        default:
            return state;
    }
}

export {exerciseReducer};
export type {TExercise, TSetExercise, TExerciseState};
